/*
 * @Author: Teemo Ding
 * @Date: 2021-06-23 11:52:55
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 10:03:52
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/StoreDetails/StoreDetailsInfo/index.tsx
 */
import { Input, Label, Select, TextArea } from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Icon } from '@/src/tools/icon';
import { Form } from 'antd';
import React from 'react';
import { optionsList } from '../config';
import css from '../css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const StoreDetailsInfo = ({ disabled = false }: { disabled?: boolean }) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  return (
    <SectionWrapper
      titleClassName={css.titleContainerAll}
      title={getI18n('settings.list.storeDetails')}
      className={css.storeDetailsInfo}>
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='name'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storeDetailsSetting.detail.storeName',
                    )}*`}
                    textLength={100}
                    rightSubTitle={getI18n(
                      'storeDetailsSetting.detail.storeNameTip',
                    )}
                    nameKey='name'
                  />
                }
                rules={[
                  {
                    required: true,
                    message: getI18n(
                      'storeDetailsSetting.detail.storeNameRequired',
                    ),
                  },
                ]}>
                <Input size='large' maxLength={100} disabled={disabled} />
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                name='industry'
                label={
                  <Label
                    title={getI18n('storeDetailsSetting.detail.storeindustry')}
                  />
                }
                labelCol={{
                  span: 24,
                }}>
                <Select
                  size='large'
                  disabled={disabled}
                  getPopupContainer={(trigger) => trigger}
                  suffixIcon={<Icon type='icondown' className={css.icon} />}
                  className={css.select}
                  placeholder={getI18n('general.pleaseselectavalue')}
                  optionsList={optionsList({ getI18n })}></Select>
              </Form.Item>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='description'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={getI18n(
                      'storeDetailsSetting.detail.descriptionofProductsorService',
                    )}
                    textLength={500}
                    nameKey='description'
                  />
                }>
                <TextArea
                  autoSize={{ minRows: 4 }}
                  maxLength={500}
                  disabled={disabled}
                />
              </Form.Item>
            ),
          },
        ]}
      />
    </SectionWrapper>
  );
};

export default StoreDetailsInfo;
